module.exports = __webpack_public_path__ + "static/media/roar3.d3796d23.mp3";